import React from 'react';
import { Flex, Stack, Text, xcss } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';
import { HelpContent } from '@css-xp/ppc-common';
// @ts-ignore
import ErrorWidget from './assets/error-widget.png';
import ErrorWidgetV2 from './assets/error-widget-v2.svg';
import './widget-error.scss';

const widgetBoxStyles = xcss({
  height: '100%',
});

export const WidgetError = ({ version }: { version?: number }) => {
  if (version === 2) {
    return (
      <Flex direction="column" justifyContent="center" alignItems="center" gap="space.300" xcss={widgetBoxStyles}>
        <Flex justifyContent="center">
          {/* @ts-ignore */}
          <img src={ErrorWidgetV2} alt="empty-widget" width="160" height="160" />
        </Flex>
        <Stack space="space.200" alignInline="center">
          <Heading size="medium">We couldn&apos;t find what you&apos;re looking for.</Heading>
          <Text>Try refreshing the page or contact our support team.</Text>
          <HelpContent contentPrefix={''} version={version} />
        </Stack>
      </Flex>
    );
  }

  return (
    <div className="ppc-widget-error flex-column justify-center" data-testid="widget-error">
      <div>
        <img src={ErrorWidget} alt="error-widget" width="314" height="146" />
        <p className="error-widget-heading mt-24">
          We couldn't find what you're looking for. Try <br /> refreshing the page or contact
          <br />
          <HelpContent contentPrefix={''} />.
        </p>
      </div>
    </div>
  );
};
